<!-- Display only / readOnly mode -->
<ng-container *ngIf="readonly">
  <div class="star-rating">
    <span
      *ngFor="let index of [1, 2, 3, 4, 5]"
      id="{{ index }}"
    >
      <ion-icon
        [name]="getIconName(index)"
        [color]="color"
      ></ion-icon>
    </span>
  </div>
  <span class="screen-reader-only"> {{ rating + ' star rating' }} </span>
</ng-container>

<!-- Edit mode -->
<div
  class="star-rating flex-between-center"
  *ngIf="!readonly"
>
  <mable-button
    [icon]="getIconName(index)"
    [color]="color"
    category="icon-only"
    *ngFor="let index of [1, 2, 3, 4, 5]"
    id="{{ index }}"
    (click)="changeRating(index)"
    [ariaLabel]="'Star rating Select ' + index + ' of five'"
  >
  </mable-button>
</div>
